// project imports
import services from 'utils/mockAdapter';

// asset
import Avatar1 from 'assets/images/users/avatar-1.png';
import Avatar2 from 'assets/images/users/avatar-2.png';
import Avatar3 from 'assets/images/users/avatar-3.png';

// user list
const users_s1 = [
    {
        id: '01',
        avatar: 'user-1.png',
        name: 'Curtis',
        verify: 1,
        email: 'wiegand@hotmail.com',
        tenants: 'Saucerize',
        role: 'User',
        lastLogin: '07-02-2022',
        status: 'Active'
    },
    {
        id: '02',
        avatar: 'user-2.png',
        name: 'Xavier',
        verify: 1,
        email: 'tyrell86@company.com',
        tenants: 'South Bradfordstad',
        role: 'User',
        lastLogin: '07-02-2022',
        status: 'Inactive'
    },
    {
        id: '03',
        avatar: 'user-3.png',
        name: 'Lola',
        verify: 1,
        email: 'aufderhar56@yahoo.com',
        tenants: 'North Tannermouth',
        role: 'User',
        lastLogin: '07-02-2022',
        status: 'Inactive'
    },
    {
        id: '04',
        avatar: 'user-4.png',
        name: 'Milton',
        verify: 1,
        email: 'dikinson49@hotmail.com',
        tenants: 'North Anika',
        role: 'User',
        lastLogin: '07-02-2022',
        status: 'Pending'
    },
    {
        id: '05',
        avatar: 'user-5.png',
        name: 'Lysanne',
        verify: 0,
        email: 'zack.turner49@company.com',
        tenants: 'Betteland',
        role: 'User',
        lastLogin: '07-02-2022',
        status: 'Active'
    },
    {
        id: '06',
        avatar: 'user-6.png',
        name: 'Bonita',
        verify: 1,
        email: 'keebler57@company.com',
        tenants: 'Alexburgh',
        role: 'User',
        lastLogin: '07-02-2022',
        status: 'Inactive'
    },
    {
        id: '07',
        avatar: 'user-7.png',
        name: 'Retta',
        verify: 1,
        email: 'mathew92@yahoo.com',
        tenants: 'East Bryceland',
        role: 'User',
        lastLogin: '07-02-2022',
        status: 'Active'
    },
    {
        id: '08',
        avatar: 'user-8.png',
        name: 'Zoie',
        verify: 1,
        email: 'hulda1@hotmail.com',
        tenants: 'Beattytown',
        role: 'User',
        lastLogin: '07-02-2022',
        status: 'Pending'
    },
    {
        id: '09',
        avatar: 'user-9.png',
        name: 'Easton',
        verify: 1,
        email: 'hilpert66@hotmail.com',
        tenants: 'North Pedromouth',
        role: 'User',
        lastLogin: '07-02-2022',
        status: 'Active'
    },
    {
        id: '10',
        avatar: 'user-10.png',
        name: 'Brianne',
        verify: 1,
        email: 'noe45@hotmail.com',
        tenants: 'New Alexanderborough',
        role: 'User',
        lastLogin: '07-02-2022',
        status: 'Active'
    }
];

const users_s2 = [
    {
        image: Avatar1,
        name: 'Elnora',
        designation: 'Lead Marketing Facilitator',
        badgeStatus: 'active',
        subContent: 'We need to generate the virtual CSS hard drive!',
        email: 'Reid_OConnell4@yahoo.com',
        phone: '506-654-1653',
        tenants: 'Saucerize',
        progressValue: '78%'
    },
    {
        image: Avatar2,
        name: 'Hirohito',
        designation: 'Investor Creative Liaison',
        badgeStatus: 'active',
        subContent: 'If we synthesize the protocol, we can get to the RSS circuit through.',
        email: 'Conner22@hotmail.com',
        phone: '673-157-1670',
        tenants: 'Port Narcos',
        progressValue: '78%'
    },
    {
        image: Avatar3,
        name: 'Kathie',
        designation: 'Human Accountability Strategist',
        badgeStatus: 'inactive',
        subContent: 'We need to generate the virtual CSS hard drive!',
        email: 'Dangelo40@company.com',
        phone: '506-654-1653',
        tenants: 'Saucerize',
        progressValue: '78%'
    }
];

// ==============================|| MOCK SERVICES ||============================== //

services.onGet('/api/user-list/s1/list').reply(200, { users_s1 });

services.onGet('/api/user-list/s2/list').reply(200, { users_s2 });
